import styled from '@emotion/styled';
import { HTMLAttributes } from 'react';

interface Props extends HTMLAttributes<HTMLButtonElement> {
    dot?: boolean;
    background?: 'base' | 'none'
    containerClassName?: string;
}

function IconButton(props: Props) {
    const {
        dot, background, containerClassName, ...rest
    } = props;
    return (
        <Container className={containerClassName}
            aria-label='icon-button'
        >
            <Base background={background}
                {...rest} />
            {dot && (
                <Dot/>
            )}
        </Container>
    );
}

const Container = styled.div`
    position: relative;
`;

const Base = styled('button')<{
    background?: 'base' | 'none'
}>`
    width: var(--spacing-14);
    height: var(--spacing-10);
    border-radius: var(--radius-m);
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    background-color: ${({ background }) => (background === 'none' ? 'transparent' : 'var(--color-background-base)')};
`;

const Dot = styled.div`
    width: var(--spacing-1-5);
    height: var(--spacing-1-5);
    background-color: var(--color-icon-error);
    border-radius: var(--radius-full);
    position: absolute;
    right: 2px;
    top: -1px;
`;

export default IconButton;
